import { clientApp } from './index';

export const checkSubscription = () => clientApp.get(`/ui/planzer/subscription`);

export const postCheckout = () =>
  clientApp.post(`/ui/planzer/subscription/checkout`, { url: process.env.REACT_APP_FE_URL + '/admin/delivery' });
